module.exports = __webpack_public_path__ + "img/vertical_7_7_3016.42de79ec.png";